import { COLORS } from '@/shared/constants/colors';

export const styles = {
  tooltip: {
    background: '#fff',
    borderRadius: '6px',
    color: COLORS.systemDark300,
    opacity: '0',
    pointerEvents: 'none',
    position: 'absolute',
    transform: 'translate(-50%, 0)',
    transition: 'all .15s ease',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    padding: '12px',
    width: 'max-content',
    zIndex: 10,
  },
  caret: {
    position: 'absolute',
    bottom: '-5px',
    left: '50%',
    transform: 'translateX(-50%)',
    borderWidth: '5px',
    borderStyle: 'solid',
    borderColor: `${COLORS.white} transparent transparent transparent`,
  },
  title: {
    fontWeight: '700',
    marginBottom: '8px',
    fontSize: '14px',
  },
  body: {
    fontSize: '12px',
  },
};
